export const PIN_PAYMENTS_PUBLISHABLE_API_KEY =
  process.env.REACT_APP_PIN_PAYMENTS_PUBLISHABLE_API_KEY;
export const PIN_PAYMENTS_URL = process.env.REACT_APP_PIN_PAYMENTS_URL;
export const CUSTOMER_MICROSERVICE_BASE_URL =
  process.env.REACT_APP_CUSTOMER_MICROSERVICE_BASE_URL;
export const COUNTRY = "AU"; // UP @ Home Registration is only available in Australia at the moment.
